import { createApp } from "vue";
import router from "./router";

/**
 * Import css
 */
import "./styles/index.scss";

/**
 * Register components
 */
import App from "./App.vue";
import CursorComponent from "./components/Cursor.component.vue";
import FooterComponent from "./components/Navigation/Footer.component.vue";
import LeftNavigation from "./components/Navigation/LeftNavigation.component.vue";
import MenuComponent from "./components/Navigation/Menu.component.vue";
import RightNavigation from "./components/Navigation/RightNavigation.component.vue";
import ScrollProgress from "./components/ScrollProgress.component.vue";
import PageHeaderComponent from "./components/Small/PageHeading.component.vue";
import NameBanner from "./components/NameBanner.component.vue";
import AppTag from "./components/AppTag.vue";
import { appWeirdTextDirective } from "./directives";
import VueGtag from "vue-gtag";

/**
 * Create app
 */
const app = createApp(App);

/**
 * Import components
 */
app
  .use(VueGtag, {
    config: { id: "G-7VGDKLDGNB" },
  })
  .use(router)
  .directive("app-weird-text", appWeirdTextDirective)
  .component("app-tag", AppTag)
  .component("app-name-banner", NameBanner)
  .component("app-cursor", CursorComponent)
  .component("app-rightnav", RightNavigation)
  .component("app-leftnav", LeftNavigation)
  .component("app-scrollprogress", ScrollProgress)
  .component("app-menu", MenuComponent)
  .component("app-footer", FooterComponent)
  .component("app-heading", PageHeaderComponent);

/**
 * Mount app
 */
app.mount("#app");
